import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {SearchTermDefinitionInf} from '../../interfaces/common/search/search-term-definition-inf';
import * as _ from 'lodash';

@Component({
  selector: 'arm-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {

  @Input() searchComponent: any;
  @Input() searchData: any;
  @Input() searchTerms: SearchTermDefinitionInf[] = [];
  @Input() localSearch = false;
  @Output() onSearch = new EventEmitter<any>();

  searchString: any;
  searchDescription: any;
  searchObject: any = {};

  constructor(public dialog: MatDialog) { }

  ngOnInit(): void {

  }

  generalSearch(): void {
    this.searchObject.searchString = this.searchString;

    this.search();
  }

  resetGeneralSearch(): void {
    this.searchString = '';
    this.generalSearch();
  }

  openAdvancedSearch(): void {
    const dialogRef: any = this.dialog.open(this.searchComponent, {
      data: _.cloneDeep(this.searchData)
    });

    dialogRef.componentInstance.onApply.subscribe(data => {
      this.searchData = data;
      this.search(data);
    });
  }

  clearAdvancedSearch(): void {
    const generatedSearch: any = {};

    this.searchTerms.forEach((searchTermObject) => {
      delete this.searchObject[searchTermObject.term];
    });

    this.searchDescription = '';

    if (!_.isEmpty(this.searchString)) {
      this.updateSearchObject(generatedSearch, 'searchString', this.searchString, ':');
    }

    this.onSearch.emit({
      filter: generatedSearch
    });
  }

  private updateSearchObject = (generatedSearch, key, value, operator) => {
    generatedSearch[key] = {
      value: _.isString(value) && !this.localSearch ?
          this.addQuotaIfNeeded(value) :
          value,
      operator
    };
  }

  private addQuotaIfNeeded(searchString): string {
    const quota = !_.isNil(searchString) && searchString !== '' ? '\'' : '';
    return quota + searchString + quota;
  }

  private search(data?): void {
    const generatedSearch: any = {};
    const searchTermsInfo: string[] = [];

    if (data) {
      this.searchObject = data;
    }

    if (this.searchTerms) {
      this.searchTerms.forEach((searchTermObject) => {
        const searchTerm = this.searchObject[searchTermObject.term];

        if (_.isNil(searchTerm)) { return; }
        const displayValue = !_.isNil(searchTermObject.displayValue) ? searchTermObject.displayValue(searchTerm) : searchTerm;

        if ((!_.isNil(searchTerm) && !Array.isArray(searchTerm)) &&
          searchTerm !== '' || (Array.isArray(searchTerm) && searchTerm.length > 0)) {
          this.updateSearchObject(generatedSearch, searchTermObject.term, searchTerm, searchTermObject.operator);

          searchTermsInfo.push(`${searchTermObject.displayName || searchTermObject.term}: ${displayValue}`);
        }
      });

      this.searchDescription = searchTermsInfo.join(', ');
    }

    if (!_.isEmpty(this.searchString)) {
      this.updateSearchObject(generatedSearch, 'searchString', this.searchString, ':');
    }
    this.searchObject.filter = generatedSearch;
    this.onSearch.emit(this.searchObject);
  }
}
